import React, {
  useState,
} from 'react';
import {
  shallowEqual,
  useSelector,
  useDispatch,
} from 'react-redux';
import {
  uiActions,
} from 'web-actions';
import {
  getUiState,
} from 'web-selectors';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  Icon,
  Popup,
  Tooltip,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';
import * as ParentS from '../../styled';

const mapState = state => ({
  items: coreSelectors.getSelectionResourceMappedList(
    'documents',
    'library',
  )(state),
  ...getUiState([
    'fileUpload',
    'uploadFileModal',
  ])(state),
});

type Props = {
  onLink: { (item: any): void },
};

const Links = ({
  onLink,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { items } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();

  return (
    <Popup
      isOpen={isOpen}
      trigger={(
        <Flex>
          <Tooltip body="Link Document" positions={['top']}>
            <ParentS.Control>
              <Icon type="fas fa-file" />
            </ParentS.Control>
          </Tooltip>
        </Flex>
      )}
      setPopupVisible={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
      }}
      onClickOutside={() => setIsOpen(false)}
    >
      <S.Dropdown>
        <Flex
          column
          padding="10px 20px 5px 20px"
          spacing={5}
        >
          <Text
            size="12px"
            color="#999999"
          >
            SELECT DOCUMENT
          </Text>
          <Flex
            align="center"
            spacing={5}
            clickable
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();

              dispatch(
                uiActions.setUiState({
                  fileUpload: {},
                  uploadFileModal: {
                    isOpen: true,
                  },
                }),
              );
              setIsOpen(false);
            }}
          >
            <S.PlusCircle />
            <Text
              color="primary"
            >
              ADD DOCUMENT
            </Text>
          </Flex>
        </Flex>
        {items.map(item => (
          <S.Item
            key={item.id}
            onMouseDown={() => {
              onLink(item);
              setIsOpen(false);
            }}
          >
            {item.name}
          </S.Item>
        ))}
      </S.Dropdown>
    </Popup>
  );
};

export default Links;
